import { GET_CERTONA_ATTRIBUTES } from '../actionTypes/CartActionTypes';

export default function CertonaAttributesReducer(state = {}, action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case GET_CERTONA_ATTRIBUTES:
            return { ...state, ...action.payload };
        default:
            return state;
    }
}
